export const POLICIES = [
  {
    slug: "privacy-policy",
    title: "Privacy Policy",
    updated: "August 28, 2026",
    source: "verbatim",
    sections: [
      {
        heading: null,
        paragraphs: [
          '01 LONDON operates this store and website, including all related information, content, features, tools, products and services, in order to provide you, the customer, with a curated shopping experience (the "Services"). 01 LONDON is powered by Shopify, which enables us to provide the Services to you. This Privacy Policy describes how we collect, use, and disclose your personal information when you visit, use, or make a purchase or other transaction using the Services or otherwise communicate with us. If there is a conflict between our Terms of Service and this Privacy Policy, this Privacy Policy controls with respect to the collection, processing, and disclosure of your personal information.',
          "Please read this Privacy Policy carefully. By using and accessing any of the Services, you acknowledge that you have read this Privacy Policy and understand the collection, use, and disclosure of your information as described in this Privacy Policy.",
        ],
      },
      {
        heading: "Personal information we collect or process",
        paragraphs: [
          'When we use the term "personal information," we are referring to information that identifies or can reasonably be linked to you or another person. Personal information does not include information that is collected anonymously or that has been de-identified, so that it cannot identify or be reasonably linked to you. We may collect or process the following categories of personal information, including inferences drawn from this personal information, depending on how you interact with the Services, where you live, and as permitted or required by applicable law:',
        ],
        bullets: [
          "Contact details including your name, address, billing address, shipping address, phone number, and email address.",
          "Financial information including credit card, debit card, and financial account numbers, payment card information, financial account information, transaction details, form of payment, payment confirmation and other payment details.",
          "Account information including your username, password, security questions, preferences and settings.",
          "Transaction information including the items you view, put in your cart, add to your wishlist, or purchase, return, exchange or cancel and your past transactions.",
          "Communications with us including the information you include in communications with us, for example, when sending a customer support inquiry.",
          "Device information including information about your device, browser, or network connection, your IP address, and other unique identifiers.",
          "Usage information including information regarding your interaction with the Services, including how and when you interact with or navigate the Services.",
        ],
      },
      {
        heading: "Personal information sources",
        paragraphs: [
          "We may collect personal information from the following sources:",
        ],
        bullets: [
          "Directly from you including when you create an account, visit or use the Services, communicate with us, or otherwise provide us with your personal information;",
          "Automatically through the Services including from your device when you use our products or services or visit our websites, and through the use of cookies and similar technologies;",
          "From our service providers including when we engage them to enable certain technology and when they collect or process your personal information on our behalf;",
          "From our partners or other third parties.",
        ],
      },
      {
        heading: "How we use your personal information",
        paragraphs: [
          "Depending on how you interact with us or which of the Services you use, we may use personal information for the following purposes:",
        ],
        bullets: [
          "Provide, Tailor, and Improve the Services. We use your personal information to provide you with the Services, including to perform our contract with you, to process your payments, to fulfill your orders, to remember your preferences and items you are interested in, to send notifications to you related to your account, to process purchases, returns, exchanges or other transactions, to create, maintain and otherwise manage your account, to arrange for shipping, to facilitate any returns and exchanges, to enable you to post reviews, and to create a customized shopping experience for you, such as recommending products related to your purchases.",
          "Marketing and Advertising. We use your personal information for marketing and promotional purposes, such as to send marketing, advertising and promotional communications by email, text message or postal mail, and to show you online advertisements for products or services on the Services or other websites, including based on items you previously have purchased or added to your cart and other activity on the Services.",
          "Security and Fraud Prevention. We use your personal information to authenticate your account, to provide a secure payment and shopping experience, detect, investigate or take action regarding possible fraudulent, illegal, unsafe, or malicious activity, protect public safety, and to secure our services. If you choose to use the Services and register an account, you are responsible for keeping your account credentials safe.",
          "Communicating with You. We use your personal information to provide you with customer support, to be responsive to you, to provide effective services to you and to maintain our business relationship with you.",
          "Legal Reasons. We use your personal information to comply with applicable law or respond to valid legal process, including requests from law enforcement or government agencies, to investigate or participate in civil discovery, potential or actual litigation, or other adversarial legal proceedings, and to enforce or investigate potential violations of our terms or policies.",
        ],
      },
      {
        heading: "How we disclose personal information",
        paragraphs: [
          "In certain circumstances, we may disclose your personal information to third parties for legitimate purposes subject to this Privacy Policy. Such circumstances may include:",
        ],
        bullets: [
          "With Shopify, vendors and other third parties who perform services on our behalf (e.g. IT management, payment processing, data analytics, customer support, cloud storage, fulfillment and shipping).",
          "With business and marketing partners to provide marketing services and advertise to you. For example, we use Shopify to support personalized advertising with third-party services based on your online activity with different merchants and websites. Depending on where you reside, you may have a right to direct us not to share information about you to show you targeted advertisements and marketing based on your online activity with different merchants and websites.",
          "When you direct, request us or otherwise consent to our disclosure of certain information to third parties, such as to ship you products or through your use of social media widgets or login integrations.",
          "With our affiliates or otherwise within our corporate group.",
          "In connection with a business transaction such as a merger or bankruptcy, to comply with any applicable legal obligations, to enforce any applicable terms of service or policies, and to protect or defend the Services, our rights, and the rights of our users or others.",
        ],
      },
      {
        heading: "Relationship with Shopify",
        paragraphs: [
          "The Services are hosted by Shopify, which collects and processes personal information about your access to and use of the Services in order to provide and improve the Services for you. Information you submit to the Services will be transmitted to and shared with Shopify as well as third parties that may be located in countries other than where you reside, in order to provide and improve the Services for you. To learn more about how Shopify uses your personal information and any rights you may have, you can visit the Shopify Consumer Privacy Policy at shopify.com/legal/privacy/app-users. Depending on where you live, you may exercise certain rights with respect to your personal information at privacy.shopify.com/en.",
        ],
      },
      {
        heading: "Third party websites and links",
        paragraphs: [
          "The Services may provide links to websites or other online platforms operated by third parties. If you follow links to sites not affiliated or controlled by us, you should review their privacy and security policies and other terms and conditions. We do not guarantee and are not responsible for the privacy or security of such sites, including the accuracy, completeness, or reliability of information found on these sites.",
        ],
      },
      {
        heading: "Children's data",
        paragraphs: [
          "The Services are not intended to be used by children, and we do not knowingly collect any personal information about children under the age of majority in your jurisdiction. If you are the parent or guardian of a child who has provided us with their personal information, you may contact us using the contact details set out below to request that it be deleted.",
        ],
      },
      {
        heading: "Security and retention of your information",
        paragraphs: [
          'Please be aware that no security measures are perfect or impenetrable, and we cannot guarantee "perfect security." In addition, any information you send to us may not be secure while in transit. We recommend that you do not use unsecure channels to communicate sensitive or confidential information to us.',
          "How long we retain your personal information depends on different factors, such as whether we need the information to maintain your account, to provide you with Services, comply with legal obligations, resolve disputes or enforce other applicable contracts and policies.",
        ],
      },
      {
        heading: "Your rights and choices",
        paragraphs: [
          "Depending on where you live, you may have some or all of the rights listed below in relation to your personal information. However, these rights are not absolute, may apply only in certain circumstances and, in certain cases, we may decline your request as permitted by law.",
        ],
        bullets: [
          "Right to Access / Know. You may have a right to request access to personal information that we hold about you.",
          "Right to Delete. You may have a right to request that we delete personal information we maintain about you.",
          "Right to Correct. You may have a right to request that we correct inaccurate personal information we maintain about you.",
          "Right of Portability. You may have a right to receive a copy of the personal information we hold about you and to request that we transfer it to a third party, in certain circumstances and with certain exceptions.",
          "Right to Opt out of Sale or Sharing for Targeted Advertising. Depending on where you reside, you may have a right to opt out of the \"sale\" or \"share\" of your personal information or to opt out of the processing of your personal information for purposes considered to be \"targeted advertising\". If you visit our website with the Global Privacy Control opt-out preference signal enabled, depending on where you are, we will automatically treat this as a request to opt-out for the device and browser that you use to visit the website.",
          "Managing Communication Preferences. We may send you promotional emails, and you may opt out of receiving these at any time by using the unsubscribe option displayed in our emails to you. If you opt out, we may still send you non-promotional emails, such as those about your account or orders that you have made.",
        ],
      },
      {
        heading: "Additional rights for UK and EEA residents",
        paragraphs: [
          "If you reside in the UK or European Economic Area, and subject to exceptions and limitations provided by local law, you may exercise the following rights in addition to the rights outlined above:",
        ],
        bullets: [
          "Objection to Processing and Restriction of Processing: You may have the right to ask us to stop or restrict our processing of personal information for certain purposes.",
          "Withdrawal of Consent: Where we rely on consent to process your personal information, you have the right to withdraw this consent. If you withdraw your consent, this will not affect the lawfulness of any processing based on your consent before its withdrawal.",
        ],
      },
      {
        heading: "Complaints and international transfers",
        paragraphs: [
          "If you have complaints about how we process your personal information, please contact us using the contact details provided below. Depending on where you live, you may have the right to appeal our decision, or lodge your complaint with your local data protection authority.",
          "Please note that we may transfer, store and process your personal information outside the country you live in. If we transfer your personal information out of the European Economic Area or the United Kingdom, we will rely on recognized transfer mechanisms like the European Commission's Standard Contractual Clauses, or any equivalent contracts issued by the relevant competent authority of the UK, unless the data transfer is to a country that has been determined to provide an adequate level of protection.",
        ],
      },
      {
        heading: "Changes to this Privacy Policy",
        paragraphs: [
          'We may update this Privacy Policy from time to time, including to reflect changes to our practices or for other operational, legal, or regulatory reasons. We will post the revised Privacy Policy on this website, update the "Last updated" date and provide notice as required by applicable law.',
        ],
      },
      {
        heading: "Contact",
        paragraphs: [
          "Should you have any questions about our privacy practices or this Privacy Policy, or if you would like to exercise any of the rights available to you, please email us at info@01london.co.uk. For the purpose of applicable data protection laws, we are the data controller of your personal information.",
        ],
      },
    ],
  },
  {
    slug: "terms-of-service",
    title: "Terms of Service",
    updated: "October 5, 2026",
    source: "draft",
    sections: [
      {
        heading: null,
        paragraphs: [
          'These Terms of Service ("Terms") govern your access to and use of the 01 LONDON website and services. By accessing or using the Services, you agree to be bound by these Terms. 01 LONDON operates this store and website, powered by Shopify, which enables us to provide the Services to you, including order processing, payments and checkout. If you have any questions, contact us at info@01london.co.uk.',
        ],
      },
      {
        heading: "Who we are",
        paragraphs: [
          "01 LONDON is a United Kingdom based brand, operating from London, United Kingdom. Our premium minimal streetwear is exclusively made in London.",
        ],
      },
      {
        heading: "Our products and pricing",
        paragraphs: [
          "All products are subject to availability. We take care to display products and their colours as accurately as possible, but slight variations may occur between screens.",
          "Prices are displayed in GBP (£) and are subject to change at any time. Where your payment provider or location requires a currency conversion, the final charged amount may differ slightly from the displayed price.",
        ],
      },
      {
        heading: "Orders",
        paragraphs: [
          "Your order is an offer to buy. We accept it when we send you an order confirmation, and the contract between us is formed at that point. If we cannot fulfil an order (for example, a size has sold out), we will cancel it and refund any payment taken in full.",
          "Preorder items are made in limited runs and dispatch within the timeframe stated on the product page. Ordering a preorder means you agree to that dispatch window.",
        ],
      },
      {
        heading: "Shipping and delivery",
        paragraphs: [
          "Delivery timelines and charges are set out in our Shipping Policy. Risk passes to you on delivery. UK orders over £75 qualify for free standard delivery.",
        ],
      },
      {
        heading: "Returns and refunds",
        paragraphs: [
          "Our Refund & Returns Policy forms part of these Terms. In summary, you may return unworn items within 14 days of delivery, and you may cancel a preorder at any time before dispatch for a full refund.",
        ],
      },
      {
        heading: "Intellectual property",
        paragraphs: [
          "All content on this website — including the 01 LONDON name, logo, designs, photography and copy — is owned by or licensed to 01 LONDON and may not be copied, reproduced or used without our written permission.",
        ],
      },
      {
        heading: "Liability",
        paragraphs: [
          "Nothing in these Terms limits your statutory rights as a consumer, including under the Consumer Rights Act 2015. Otherwise, our liability for any claim connected with the Services is limited to the amount you paid for the products concerned. We are not liable for losses caused by events beyond our reasonable control.",
        ],
      },
      {
        heading: "Governing law",
        paragraphs: [
          "These Terms are governed by the laws of England and Wales. UK and EU consumers may also rely on mandatory protections of their local law, and may use alternative dispute resolution where available.",
        ],
      },
      {
        heading: "Contact",
        paragraphs: [
          "Questions about these Terms: email info@01london.co.uk.",
        ],
      },
    ],
  },
  {
    slug: "refund-policy",
    title: "Refund & Returns Policy",
    updated: "October 5, 2026",
    source: "draft",
    sections: [
      {
        heading: null,
        paragraphs: [
          "We want you to be completely satisfied with your 01 LONDON pieces. If something isn't right, here is exactly how returns and refunds work.",
        ],
      },
      {
        heading: "14-day returns",
        paragraphs: [
          "If you're not completely satisfied, you can return items within 14 days of receiving your order. Items must be unworn, unwashed and in their original condition with tags attached. Contact info@01london.co.uk with your order number to start a return, and we'll send you the return instructions.",
        ],
      },
      {
        heading: "Refunds",
        paragraphs: [
          "Once your return is received and inspected, we'll refund the payment method you used for the order. Please allow a few working days for the refund to appear, depending on your payment provider. Original delivery charges are refunded for faulty items and where required by law.",
        ],
      },
      {
        heading: "Faulty or damaged items",
        paragraphs: [
          "If an item arrives damaged or develops a fault, email us a photo and your order number — we'll arrange a replacement or a full refund, including any delivery costs.",
        ],
      },
      {
        heading: "Preorders",
        paragraphs: [
          "Because preorder pieces are produced in limited runs, you may cancel a preorder at any time before dispatch for a full refund — just email info@01london.co.uk with your order number. Once a preorder has shipped, our standard 14-day returns apply.",
        ],
      },
      {
        heading: "Non-returnable cases",
        paragraphs: [
          "We can't accept items that have been worn, washed, altered, or returned after the 14-day window, unless the item is faulty.",
        ],
      },
      {
        heading: "Contact",
        paragraphs: [
          "To start a return or ask a question: info@01london.co.uk — London, United Kingdom.",
        ],
      },
    ],
  },
  {
    slug: "shipping-policy",
    title: "Shipping Policy",
    updated: "October 5, 2026",
    source: "draft",
    sections: [
      {
        heading: null,
        paragraphs: [
          "We dispatch from within the UK and ship worldwide. Orders are typically dispatched within 24–48 hours of ordering.",
        ],
      },
      {
        heading: "Delivery times and charges",
        paragraphs: [
          "UK Standard Delivery: 2–5 working days. UK Express: 1–3 working days. Orders over £75 qualify for free UK delivery. Europe: 5–10 working days. Rest of World: 7–14 working days. Exact delivery charges are shown at checkout before you pay.",
        ],
      },
      {
        heading: "Preorder items",
        paragraphs: [
          "Items marked \u201cPreorder\u201d dispatch within 2 weeks of ordering. If your order mixes in-stock and preorder pieces and you would like the in-stock pieces sooner, email info@01london.co.uk and we will do our best to split the delivery.",
        ],
      },
      {
        heading: "International duties and taxes",
        paragraphs: [
          "International orders may be subject to import duties and taxes on arrival, which are set by your local customs authority and are the responsibility of the customer.",
        ],
      },
      {
        heading: "Tracking and delivery issues",
        paragraphs: [
          "Every order includes tracking, which we email to you once it ships. If your order is late or marked delivered but hasn't arrived, contact info@01london.co.uk and we'll investigate with the carrier.",
        ],
      },
    ],
  },
  {
    slug: "contact-information",
    title: "Contact Information",
    updated: "October 5, 2026",
    source: "draft",
    sections: [
      {
        heading: null,
        paragraphs: [
          "We're a small team and we read every message. The fastest way to reach us is email.",
        ],
      },
      {
        heading: "Get in touch",
        paragraphs: ["Email: info@01london.co.uk", "Address: London, United Kingdom"],
      },
      {
        heading: "What to include",
        paragraphs: [
          "For order questions, include your order number and the email address you ordered with — we can usually resolve sizing, shipping and returns questions within one working day.",
        ],
      },
    ],
  },
];
